import type { Breakpoint } from "@emkit/builder-core";
import { useEditor } from "../store.js";

const OPTIONS: { bp: Breakpoint; label: string; icon: string; width: string }[] = [
  { bp: "desktop", label: "Desktop", icon: "▭", width: "1200+" },
  { bp: "tablet", label: "Tablet", icon: "▤", width: "768" },
  { bp: "mobile", label: "Mobile", icon: "▯", width: "390" },
];

export function BreakpointSwitcher() {
  const current = useEditor((s) => s.breakpoint);
  const setBreakpoint = useEditor((s) => s.setBreakpoint);

  return (
    <div className="emke-bp-switcher" role="tablist" aria-label="Breakpoint">
      {OPTIONS.map((opt) => (
        <button
          key={opt.bp}
          type="button"
          role="tab"
          aria-selected={current === opt.bp}
          className={`emke-bp-option${current === opt.bp ? " is-active" : ""}`}
          onClick={() => setBreakpoint(opt.bp)}
          title={`${opt.label} (${opt.width}px)`}
        >
          <span className="emke-bp-icon">{opt.icon}</span>
          <span className="emke-bp-label">{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
